import { memo } from "react";
import type { FC } from "react";

import resets from "../_resets.module.css";
import classes from "./Top.module.scss";

/*Title*/
import { PageTitle } from "../common/PageTitle/PageTitle";
/*section*/
import { Contact } from "../common/Contact/Contact";

interface Props {
    className?: string;
  }


  export const SchoolList: FC<Props> = memo(function SchoolList(props = {}) {
    return (

        <div className='contents'>

<PageTitle
          className={classes.pageTitle}
          title="導入校一覧"
        />

<ul>
              <li className={classes.schoolListItem}>愛媛県立東伊予高等学校</li>
              <li className={classes.schoolListItem}>葛飾区立飯塚小学校</li>
              <li className={classes.schoolListItem}>金沢学院大学</li>
              <li className={classes.schoolListItem}>広島県立広島井口高等学校</li>
              <li className={classes.schoolListItem}>江戸川区立下鎌田西小学校</li>
              <li className={classes.schoolListItem}>芝浦工業大学 附属中学高等学校</li>
              <li className={classes.schoolListItem}>芝浦工大</li>
              <li className={classes.schoolListItem}>渋谷区立鉢山中学校</li>
              <li className={classes.schoolListItem}>神戸龍谷高等学校</li>
              <li className={classes.schoolListItem}>神奈川大学</li>
              <li className={classes.schoolListItem}>秦野市立本町中学校</li>
              <li className={classes.schoolListItem}>杉並区立天沼中学校</li>
              <li className={classes.schoolListItem}>西東京市立田無小学校</li>
              <li className={classes.schoolListItem}>青梅市立第二小学校</li>
              <li className={classes.schoolListItem}>石川県立小松明峰高等学校</li>
              <li className={classes.schoolListItem}>川崎市立平中学校</li>
              <li className={classes.schoolListItem}>大田区立南六郷小学校</li>
              <li className={classes.schoolListItem}>大島町立第一中学校</li>
              <li className={classes.schoolListItem}>中野区立南台小学校</li>
              <li className={classes.schoolListItem}>町田市小山田南小学校</li>
              <li className={classes.schoolListItem}>町田市立小川小学校</li>
              <li className={classes.schoolListItem}>町田市立大戸小学校</li>
              <li className={classes.schoolListItem}>町田市立武蔵丘中学校</li>
              <li className={classes.schoolListItem}>追手門中学高校</li>
              <li className={classes.schoolListItem}>都立中野工業高等学校</li>
              <li className={classes.schoolListItem}>都立北豊島工業高等学校</li>
              <li className={classes.schoolListItem}>都立墨田工業高等学校</li>
              <li className={classes.schoolListItem}>土浦市立新治学園義務教育学校</li>
              <li className={classes.schoolListItem}>東久留米第一小学校</li>
              <li className={classes.schoolListItem}>東京学芸大学附属世田谷小学校</li>
              <li className={classes.schoolListItem}>東京都立神代高等学校定時制</li>
              <li className={classes.schoolListItem}>東京都立蔵前工業高等学校</li>
              <li className={classes.schoolListItem}>八丈高等学校定時制</li>
              <li className={classes.schoolListItem}>品川区立荏原第一中学校</li>
              <li className={classes.schoolListItem}>武蔵村山市立第一小学校</li>
              <li className={classes.schoolListItem}>福井市大東中学校</li>
              <li className={classes.schoolListItem}>福岡第一高校</li>
              <li className={classes.schoolListItem}>文京区立指ヶ谷小学校</li>
              <li className={classes.schoolListItem}>豊島高等学校</li>
              <li className={classes.schoolListItem}>墨田区立横川小学校</li>
              <li className={classes.schoolListItem}>練馬区立石神井南中学校</li>
            </ul>

        {/*contact------------*/}
<Contact className={classes.contact} />


</div>
        );
    });